var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangle10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 613,
    viewBox: "0 0 316 613",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.8128 0.5H266.187C293.45 0.5 315.5 21.3143 315.5 46.9282V566.072C315.5 591.686 293.45 612.5 266.187 612.5H49.8128C22.5496 612.5 0.5 591.686 0.5 566.072V46.9282C0.5 21.3143 22.5496 0.5 49.8128 0.5Z",
    fill: "#141922",
    stroke: "#3C485A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle10);
export default __webpack_public_path__ + "static/media/rectangle-10.1ddfc09c8c24e5240db1d459d05180fc.svg";
export { ForwardRef as ReactComponent };